/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type RoomPreferencesSettings_viewer = {
    readonly roomQueryResult: {
        readonly __typename: "GraphEntityError";
        readonly message: string | null;
        readonly statusCode: number | null;
    } | {
        readonly __typename: "ExternalRoomSearchResult";
        readonly searchQuery: string;
        readonly cacheable: boolean;
        readonly rooms: ReadonlyArray<{
            readonly roomId: string;
            readonly name: string;
            readonly orgId: string;
            readonly estimatedCapacity: number | null;
            readonly reportedCapacity: number | null;
        }>;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly " $refType": "RoomPreferencesSettings_viewer";
};
export type RoomPreferencesSettings_viewer$data = RoomPreferencesSettings_viewer;
export type RoomPreferencesSettings_viewer$key = {
    readonly " $data"?: RoomPreferencesSettings_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"RoomPreferencesSettings_viewer">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [
        {
            "defaultValue": [],
            "kind": "LocalArgument",
            "name": "excludeCalendars"
        },
        {
            "defaultValue": "",
            "kind": "LocalArgument",
            "name": "orgRelayId"
        },
        {
            "defaultValue": "",
            "kind": "LocalArgument",
            "name": "queryInput"
        }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RoomPreferencesSettings_viewer",
    "selections": [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "excludeCalendars",
                    "variableName": "excludeCalendars"
                },
                {
                    "kind": "Variable",
                    "name": "orgRelayId",
                    "variableName": "orgRelayId"
                },
                {
                    "kind": "Variable",
                    "name": "query",
                    "variableName": "queryInput"
                }
            ],
            "concreteType": null,
            "kind": "LinkedField",
            "name": "roomQueryResult",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "message",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "statusCode",
                            "storageKey": null
                        }
                    ],
                    "type": "GraphEntityError",
                    "abstractKey": null
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "searchQuery",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cacheable",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Room",
                            "kind": "LinkedField",
                            "name": "rooms",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "roomId",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "orgId",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "estimatedCapacity",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "reportedCapacity",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "type": "ExternalRoomSearchResult",
                    "abstractKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Viewer",
    "abstractKey": null
} as any;
(node as any).hash = 'a3b6923b7f8862478d9c0caea2a440ff';
export default node;
